import type { CSSProperties } from 'react';

export const analyticsLayout: CSSProperties = {
  maxWidth: 1200,
  margin: '0 auto',
  padding: 24,
};

export const title: CSSProperties = {
  margin: '0 0 8px',
  fontSize: 24,
  fontWeight: 600,
  color: '#1a1a1a',
};

export const subNav: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  marginBottom: 24,
};

export const subNavLink: CSSProperties = {
  fontSize: 14,
  padding: '8px 14px',
  borderRadius: 6,
  border: '1px solid #e5e7eb',
  background: '#fff',
  color: '#374151',
  textDecoration: 'none',
};

export const subNavLinkActive: CSSProperties = {
  background: '#eff6ff',
  borderColor: '#93c5fd',
  color: '#1d4ed8',
  fontWeight: 600,
};

export const card: CSSProperties = {
  background: '#fff',
  padding: 24,
  borderRadius: 8,
  marginBottom: 24,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

export const metricGrid: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
  gap: 16,
  marginBottom: 20,
};

export const metric: CSSProperties = {
  padding: 16,
  background: '#f9fafb',
  borderRadius: 8,
  border: '1px solid #e5e7eb',
};

export const metricLabel: CSSProperties = {
  fontSize: 12,
  color: '#6b7280',
  marginBottom: 4,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.02em',
};

export const metricValue: CSSProperties = {
  fontSize: 22,
  fontWeight: 600,
  color: '#111827',
};

export const sectionTitle: CSSProperties = {
  margin: '0 0 12px',
  fontSize: 16,
  fontWeight: 600,
  color: '#374151',
};

export const note: CSSProperties = {
  fontSize: 13,
  color: '#6b7280',
  marginTop: 8,
};

export const filterRow: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 12,
  alignItems: 'flex-end',
  marginBottom: 16,
};

export const input: CSSProperties = {
  padding: '8px 12px',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  minWidth: 200,
  font: 'inherit',
};

export const secondaryButton: CSSProperties = {
  padding: '8px 16px',
  background: '#f3f4f6',
  color: '#374151',
  border: '1px solid #d1d5db',
  borderRadius: 6,
  cursor: 'pointer',
  font: 'inherit',
};
